(function () {
  'use strict';

  function profile(correction, schedule, tier, priorities, eligible) {
    return Object.freeze({
      correction: correction,
      schedule: schedule,
      tier: tier || 'standard',
      priorities: Object.freeze(priorities || []),
      eligible: eligible !== false,
    });
  }

  window.QEQuizProductProfiles = Object.freeze({
    // Acuvue
    '1-day-acuvue-oasys-with-hydraluxe': profile('spherical', 'daily', 'premium', ['comfort', 'screens']),
    '1-day-acuvue-moist-daily-lens': profile('spherical', 'daily', 'standard', ['handling']),
    '1-day-acuvue-moist-for-astigmatism': profile('toric', 'daily', 'standard', ['handling']),
    '1-day-acuvue-moist-multifocal': profile('multifocal', 'daily', 'standard', ['handling']),
    'acuvue-oasys-1-day-for-astigmatism': profile('toric', 'daily', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-for-astigmatism': profile('toric', 'two-weekly', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-max-1-day': profile('spherical', 'daily', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-max-1-day-multifocal': profile('multifocal', 'daily', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-max-1-day-for-astigmatism-30-pack': profile('toric', 'daily', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-multifocal': profile('multifocal', 'two-weekly', 'premium', ['comfort', 'screens']),
    'acuvue-oasys-with-hydraclear-plus': profile('spherical', 'two-weekly', 'premium', ['comfort', 'screens']),
    'acuvue\u00ae-oasys-max-1-day-multifocal-for-astigmatism': profile('toric-multifocal', 'daily', 'premium', ['comfort', 'screens']),

    // Alcon
    'air-optix-colors': profile('spherical', 'monthly', 'standard', [], false),
    'air-optix-for-astigmatism': profile('toric', 'monthly', 'standard', ['comfort']),
    'air-optix-plus-hydraglyde': profile('spherical', 'monthly', 'standard', ['comfort']),
    'air-optix-plus-hydraglyde-multifocal': profile('multifocal', 'monthly', 'standard', ['comfort']),
    'dailies-aquacomfort-plus': profile('spherical', 'daily', 'value', ['handling']),
    'dailies-aquacomfort-plus-multifocal': profile('multifocal', 'daily', 'value', ['handling']),
    'dailies-aquacomfort-plus-toric': profile('toric', 'daily', 'value', ['handling']),
    'dailies-total-1-contact-lenses': profile('spherical', 'daily', 'premium', ['comfort']),
    'dailies-total-1-for-astigmatism': profile('toric', 'daily', 'premium', ['comfort']),
    'dailies-total-1-multifocal': profile('multifocal', 'daily', 'premium', ['comfort']),
    'focus-dailies-all-day-comfort': profile('spherical', 'daily', 'value', ['handling']),
    'freshlook-colorblends': profile('spherical', 'monthly', 'standard', [], false),
    'freshlook-illuminate': profile('spherical', 'daily', 'standard', [], false),
    'freshlook-one-day': profile('spherical', 'daily', 'standard', [], false),
    'precision1-daily-contact-lens': profile('spherical', 'daily', 'standard', ['comfort', 'handling']),
    'precision1-astigmatism-daily-lens': profile('toric', 'daily', 'standard', ['comfort', 'handling']),
    'total-30': profile('spherical', 'monthly', 'premium', ['comfort']),
    'total-30-for-astigmatism': profile('toric', 'monthly', 'premium', ['comfort']),
    'total-30-multifocal': profile('multifocal', 'monthly', 'premium', ['comfort']),

    // CooperVision
    'avaira-vitality': profile('spherical', 'monthly', 'value', ['comfort']),
    'avaira-vitality-toric': profile('toric', 'monthly', 'value', ['comfort']),
    'biofinity': profile('spherical', 'monthly', 'standard', ['comfort']),
    'biofinity-energys': profile('spherical', 'monthly', 'standard', ['comfort', 'screens']),
    'biofinity-multifocal': profile('multifocal', 'monthly', 'standard', ['comfort']),
    'biofinity-toric': profile('toric', 'monthly', 'standard', ['comfort']),
    'biofinity-toric-multifocal': profile('toric-multifocal', 'monthly', 'specialty', ['comfort']),
    'biofinity-xr-toric': profile('toric', 'monthly', 'specialty', ['comfort']),
    'biofinity-xr': profile('spherical', 'monthly', 'specialty', ['comfort']),
    'biomedics-1-day-extra': profile('spherical', 'daily', 'value', ['handling']),
    'biomedics-1-day-extra-toric': profile('toric', 'daily', 'value', ['handling']),
    'clariti-1-day': profile('spherical', 'daily', 'value', ['comfort']),
    'clariti-1-day-multifocal': profile('multifocal', 'daily', 'value', ['comfort']),
    'clariti-1-day-toric': profile('toric', 'daily', 'value', ['comfort']),
    'clariti-elite': profile('spherical', 'monthly', 'value', ['comfort']),
    'clariti-multifocal': profile('multifocal', 'monthly', 'value', ['comfort']),
    'clariti-toric': profile('toric', 'monthly', 'value', ['comfort']),
    'clariti-toric-xr': profile('toric', 'monthly', 'specialty', ['comfort']),
    'live': profile('spherical', 'daily', 'value', ['handling']),
    'myday': profile('spherical', 'daily', 'standard', ['comfort']),
    'myday-multifocal': profile('multifocal', 'daily', 'standard', ['comfort']),
    'myday-toric': profile('toric', 'daily', 'standard', ['comfort']),
    'proclear-1-day': profile('spherical', 'daily', 'value', ['comfort']),
    'proclear-1-day-multifocal': profile('multifocal', 'daily', 'value', ['comfort']),

    // Bausch + Lomb
    'biotrue-oneday': profile('spherical', 'daily', 'standard', ['comfort', 'handling']),
    'biotrue-oneday-for-astigmatism': profile('toric', 'daily', 'standard', ['comfort', 'handling']),
    'biotrue-oneday-for-presbyopia': profile('multifocal', 'daily', 'standard', ['comfort', 'handling']),
    'ultra': profile('spherical', 'monthly', 'standard', ['comfort', 'screens']),
    'ultra-for-astigmatism': profile('toric', 'monthly', 'standard', ['comfort', 'screens']),
    'ultra-for-presbyopia': profile('multifocal', 'monthly', 'standard', ['comfort', 'screens']),
    'ultra-one-day': profile('spherical', 'daily', 'premium', ['comfort', 'screens']),
    'ultra-one-day-multifocal-lens': profile('multifocal', 'daily', 'premium', ['comfort', 'screens']),
  });
})();
